'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import CarouselBlock, { CarouselData, ItemProps } from './CarouselBlock';
import { SimpleNewsQueryAndOptions } from '@benzinga/internal-news-manager';
import { SessionContext } from '@benzinga/session-context';
import { BasicNewsManager, formatToSimpleNewsQueryParams } from '@benzinga/basic-news-manager';
import { formatImageUrl } from '@benzinga/utils';

export interface CarouselNewsProps {
  attrs: {
    data: {
      query: SimpleNewsQueryAndOptions;
      initialItems?: ItemProps[];
      default_image?: string;
    } & CarouselData;
  };
}

export const CarouselNewsBlock: React.FC<CarouselNewsProps> = ({ attrs }) => {
  const session = React.useContext(SessionContext);
  const basicNewsManager = session.getManager(BasicNewsManager);
  const [items, setItems] = React.useState<ItemProps[]>(attrs?.data?.initialItems ?? []);

  React.useEffect(() => {
    if (!items.length && attrs?.data?.query) {
      const queryParams = formatToSimpleNewsQueryParams(attrs?.data?.query);
      basicNewsManager.simplyQueryNews(queryParams.query, queryParams.options).then(res => {
        if (Array.isArray(res?.ok)) {
          const formattedItems = res.ok.map(item => ({
            href: item.url?.replace('https://www.benzinga.com', ''),
            id: item.id ?? null,
            image: formatImageUrl(item, true) || attrs?.data?.default_image,
            isBzPost: item.isBzPost ?? null,
            isBzProPost: item.isBzProPost ?? null,
            title: item.title ?? null,
          })) as ItemProps[];
          setItems(formattedItems);
        }
      });
    }
  }, [attrs?.data?.default_image, attrs?.data?.query, basicNewsManager, items]);

  return (
    <Container>
      <CarouselBlock attrs={{ ...attrs }} items={items} />
    </Container>
  );
};

const Container = styled.div`
  margin: 1rem auto;
`;
